import {
  EuiPageTemplate,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButton,
  EuiThemeProvider,
} from "@inscopix/ideas-eui";
import { useDataTableContext } from "../store/DataTableProvider";
import { ButtonStartTasks } from "./ButtonStartTasks";
import { useTourStep } from "providers/TourProvider/TourProvider.hooks";
import { GridApi } from "ag-grid-community";
import { DataTableRowData } from "./DataTable";

export interface DataTableBottomBarProps {
  selectedRowIds: string[];
  gridApi: GridApi<DataTableRowData> | undefined;
  tableId: string;
}
/*
 * Displays a sticky bottom bar for data and analysis table controls
 * Left hand side toggles project file browser flyout
 * Right hand side shows button to start tasks for analysis tables
 */
export const DataTableBottomBar = ({
  selectedRowIds,
  gridApi,
  tableId,
}: DataTableBottomBarProps) => {
  const selectedTableType: "data" | "analysis" | "workflow" | undefined =
    useDataTableContext((s) => {
      const { tables } = s;
      const selectedTable = tables?.find((table) => table.id === tableId);
      return selectedTable?.kind;
    });
  const flyoutBottomContent = useDataTableContext((s) => s.flyoutBottomContent);
  const setFlyoutBottomContent = useDataTableContext(
    (s) => s.setFlyoutBottomContent,
  );

  const toggleFileBrowser = () => {
    setFlyoutBottomContent(
      flyoutBottomContent === "fileBrowser" ? undefined : "fileBrowser",
    );
  };

  const { component: TourDataTableUploadFiles0, anchorId } = useTourStep(
    "TourDataTableUploadFiles",
    0,
    () => {
      setFlyoutBottomContent("fileBrowser");
    },
  );

  return (
    <EuiPageTemplate.BottomBar paddingSize="s" restrictWidth={false}>
      <EuiFlexGroup justifyContent="spaceBetween" responsive={false}>
        <EuiFlexItem grow={false}>
          <EuiButton
            iconType="documents"
            color="text"
            size="s"
            onClick={toggleFileBrowser}
            fill={flyoutBottomContent === "fileBrowser"}
            id={anchorId}
          >
            Files
          </EuiButton>

          <EuiThemeProvider colorMode="light">
            {TourDataTableUploadFiles0}
          </EuiThemeProvider>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiThemeProvider colorMode="light">
            {(selectedTableType === "analysis" ||
              selectedTableType === "workflow") && (
              <ButtonStartTasks
                selectedRowIds={selectedRowIds}
                gridApi={gridApi}
                tableId={tableId}
              />
            )}
          </EuiThemeProvider>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPageTemplate.BottomBar>
  );
};
